import { MenuItem, TextField } from '@mui/material';

/**
 * GuruPay's industry category for a business client (their `industry_type`).
 * A classification staff choose from the company's actual activity; never
 * derived. Asked once and kept on the client's file: the legal-name
 * correction and the GuruPay account opening both start from the stored one.
 */
export const GURUPAY_INDUSTRY_TYPES: ReadonlyArray<[number, string]> = [
  [1, 'Luxury Goods'], [2, 'Agriculture'], [3, 'Commerce'], [4, 'Construction & Real Estate'], [5, 'Financial & Professional Services'],
  [6, 'Hospitality & Tourism'], [7, 'Mining'], [8, 'Media, Marketing & IT'], [9, 'Oil & Gas'], [10, 'Postal & Telecommunications'],
  [11, 'Education & Public Service'], [12, 'Shipping & Logistics'], [13, 'Financial Activities'], [14, 'Gambling & Betting'],
  [15, 'Investment Dealers'], [16, 'Virtual Currency'], [18, 'Accumulation Account'], [19, 'Foundation / Trust'], [20, 'Holding Company'],
];

interface GurupayIndustryTypeFieldProps {
  readonly value: number | null;
  readonly onChange: (value: number) => void;
  readonly helperText: string;
}

export function GurupayIndustryTypeField({ value, onChange, helperText }: GurupayIndustryTypeFieldProps): JSX.Element {
  return <TextField select label="GuruPay industry type" value={value ?? ''} required fullWidth
    onChange={(event) => onChange(Number(event.target.value))} helperText={helperText}>
    {GURUPAY_INDUSTRY_TYPES.map(([code, label]) => <MenuItem key={code} value={code}>{label}</MenuItem>)}
  </TextField>;
}
